/* ============================================================================
   SwagOS Catalog - storefront behaviour
   Progressive enhancement only. Filtering, sorting and pagination are
   server rendered by Shopify; this file handles the interface around them.
   ========================================================================== */
(function () {
  'use strict';

  /* Several sections load this file, so guard against running twice. */
  if (window.__swagosCatalogInit) return;
  window.__swagosCatalogInit = true;

  var FAV_KEY = 'swagos:favs';
  var ART_KEY = 'swagos:artwork';

  function read(key, fallback) {
    try { var v = localStorage.getItem(key); return v === null ? fallback : JSON.parse(v); }
    catch (e) { return fallback; }
  }
  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* private mode */ }
  }

  /* ---------------------------------------------------------------- favourites */
  var favs = read(FAV_KEY, []);
  if (!Array.isArray(favs)) favs = [];

  function paintFavs(root) {
    (root || document).querySelectorAll('.sw-fav').forEach(function (btn) {
      var on = favs.indexOf(btn.dataset.handle) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.title = on ? 'Remove from favorites' : 'Save to favorites';
    });
    document.querySelectorAll('[data-sw-fav-count]').forEach(function (el) {
      el.textContent = favs.length ? ' (' + favs.length + ')' : '';
    });
  }

  function toggleFav(handle) {
    var i = favs.indexOf(handle);
    var removed = i > -1;
    if (removed) favs.splice(i, 1); else favs.push(handle);
    write(FAV_KEY, favs);
    paintFavs();
    if (removed) {
      pruneFavShell(handle);
    } else {
      addFavCard(handle);
      var c = document.querySelector('[data-sw-count]');
      if (c) c.textContent = favs.length + (favs.length === 1 ? ' product' : ' products');
      var em = document.querySelector('[data-sw-favs-empty]');
      if (em) em.hidden = true;
    }
  }

  /* The favourites shelf is filled from the viewer's own saved handles, each
     card fetched through the Section Rendering API, so favourites work across
     the whole catalog and not just the products on the current page. */
  var favShellDone = false;
  function fillFavShell() {
    var shell = document.querySelector('[data-sw-favs-shell]');
    if (!shell) return;
    var count = document.querySelector('[data-sw-count]');
    var empty = document.querySelector('[data-sw-favs-empty]');

    if (count) count.textContent = favs.length + (favs.length === 1 ? ' product' : ' products');
    if (!favs.length) {
      shell.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    if (favShellDone) return;
    favShellDone = true;
    favs.forEach(addFavCard);
  }

  function addFavCard(handle) {
    var shell = document.querySelector('[data-sw-favs-shell]');
    if (!shell) return;
    if (shell.querySelector('.sw-card[data-handle="' + handle + '"]')) return;
    fetch('/products/' + encodeURIComponent(handle) + '?section_id=swagos-fav-card')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.sw-card');
        if (card) { shell.appendChild(card); paintFavs(shell); }
      })
      .catch(function () { /* a deleted product simply does not appear */ });
  }

  /* Removing a favourite from the shelf takes its card out immediately. */
  function pruneFavShell(handle) {
    var shell = document.querySelector('[data-sw-favs-shell]');
    if (!shell) return;
    var card = shell.querySelector('.sw-card[data-handle="' + handle + '"]');
    if (card) card.remove();
    var count = document.querySelector('[data-sw-count]');
    if (count) count.textContent = favs.length + (favs.length === 1 ? ' product' : ' products');
    var empty = document.querySelector('[data-sw-favs-empty]');
    if (empty) empty.hidden = favs.length > 0;
  }

  function filterToFavs() { fillFavShell(); }

  /* ------------------------------------------------------------ artwork chip */
  var art = read(ART_KEY, 0);
  if (typeof art !== 'number' || art < 0 || art > 3) art = 0;

  function paintArt() {
    var names = ['Primary lockup', 'White knockout', 'Icon only', 'Blank product photos'];
    document.querySelectorAll('[data-sw-art-root]').forEach(function (root) {
      root.classList.toggle('sw-nologo', art === 3);
    });
    document.querySelectorAll('[data-sw-art-title]').forEach(function (el) {
      el.textContent = art === 3 ? 'No logo' : 'Displayed with logo';
    });
    document.querySelectorAll('[data-sw-art-sub]').forEach(function (el) { el.textContent = names[art]; });
    document.querySelectorAll('[data-sw-art-option]').forEach(function (btn) {
      var tick = btn.querySelector('.tick');
      if (tick) tick.classList.toggle('off', Number(btn.dataset.swArtOption) !== art);
    });
    var thumb = document.querySelector('[data-sw-art-thumb]');
    if (thumb) thumb.textContent = art === 2 ? 'M' : (art === 3 ? '' : 'ML');
  }

  /* --------------------------------------------------------------- hero slides */
  function initBanner(banner) {
    var slides = banner.querySelectorAll('.sw-slide');
    var dots = banner.querySelectorAll('.sw-dots button');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) {
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function start() {
      if (reduce || banner.dataset.autoplay === 'false') return;
      stop();
      timer = setInterval(function () { show(i + 1); }, Number(banner.dataset.interval || 6000));
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { show(k); start(); });
    });

    /* Arrows. They live outside the slides, so one pair drives the whole
       carousel and the index never has to be reconciled across duplicates. */
    var prev = banner.querySelector('[data-sw-prev]');
    var next = banner.querySelector('[data-sw-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });

    banner.addEventListener('mouseenter', stop);
    banner.addEventListener('mouseleave', start);
    show(0);
    start();
  }

  /* ------------------------------------------------------------------- events */
  document.addEventListener('click', function (e) {
    var fav = e.target.closest('.sw-fav');
    if (fav) { e.preventDefault(); return toggleFav(fav.dataset.handle); }

    var artBtn = e.target.closest('[data-sw-art-toggle]');
    if (artBtn) {
      var menu = document.querySelector('[data-sw-art-menu]');
      if (menu) { menu.hidden = !menu.hidden; artBtn.setAttribute('aria-expanded', String(!menu.hidden)); }
      return;
    }
    var opt = e.target.closest('[data-sw-art-option]');
    if (opt) {
      art = Number(opt.dataset.swArtOption); write(ART_KEY, art); paintArt();
      var m = document.querySelector('[data-sw-art-menu]'); if (m) m.hidden = true;
      return;
    }
    if (!e.target.closest('[data-sw-art-menu]')) {
      var open = document.querySelector('[data-sw-art-menu]');
      if (open && !open.hidden) open.hidden = true;
    }

    /* Group controls (Category, Color) toggle every member checkbox they own,
       then submit, so a merged group behaves like one filter value. */
    var groupBtn = e.target.closest('[data-sw-group]');
    if (groupBtn) {
      var id = groupBtn.dataset.swGroup;
      var turnOn = !groupBtn.classList.contains('on');
      document.querySelectorAll('[data-sw-member="' + id + '"]').forEach(function (m) {
        m.checked = turnOn;
      });
      groupBtn.classList.toggle('on', turnOn);
      var gform = groupBtn.closest('form');
      if (gform) gform.submit();
      return;
    }

    /* Browse by: the segmented control only sets state, CSS decides what shows. */
    var seg = e.target.closest('[data-sw-seg]');
    if (seg) {
      var block = seg.closest('[data-sw-browseby]');
      if (block) {
        block.dataset.active = seg.dataset.swSeg;
        block.querySelectorAll('[data-sw-seg]').forEach(function (b) {
          b.setAttribute('aria-selected', String(b === seg));
        });
      }
      return;
    }
    var showall = e.target.closest('[data-sw-showall]');
    if (showall) {
      /* The combined Browse by section groups its shelves; the standalone
         Categories and Brands sections use .sw-section for the same job. */
      var g = showall.closest('.sw-bb-group, .sw-section');
      g.classList.toggle('expanded');
      var openAll = g.classList.contains('expanded');
      showall.childNodes[0].nodeValue = (openAll ? showall.dataset.less : showall.dataset.more) + ' ';
      return;
    }

    var grp = e.target.closest('.sw-gh');
    if (grp) {
      var wrap = grp.closest('.sw-grp');
      wrap.dataset.open = wrap.dataset.open === 'true' ? 'false' : 'true';
      return;
    }
    var more = e.target.closest('.sw-more');
    if (more) {
      var g2 = more.closest('.sw-grp');
      g2.classList.toggle('expanded');
      more.textContent = g2.classList.contains('expanded') ? more.dataset.less : more.dataset.more;
      return;
    }
    var scroller = e.target.closest('[data-sw-scroll]');
    if (scroller) {
      var rail = document.getElementById(scroller.dataset.swScroll);
      if (rail) rail.scrollBy({ left: Number(scroller.dataset.dir) * Math.max(280, rail.clientWidth * 0.8), behavior: 'smooth' });
      return;
    }
    if (e.target.closest('[data-sw-drawer-open]')) { document.body.classList.add('sw-drawer-open'); return; }
    if (e.target.closest('[data-sw-drawer-close]')) { document.body.classList.remove('sw-drawer-open'); return; }
    if (document.body.classList.contains('sw-drawer-open') && !e.target.closest('.sw-facets')) {
      document.body.classList.remove('sw-drawer-open');
    }

    if (e.target.closest('[data-sw-launch]')) {
      var panel = document.querySelector('[data-sw-panel]');
      var launcher = document.querySelector('.sw-launcher');
      if (panel) { panel.hidden = false; if (launcher) launcher.hidden = true; }
      return;
    }
    if (e.target.closest('[data-sw-panel-close]')) {
      var p = document.querySelector('[data-sw-panel]');
      var l = document.querySelector('.sw-launcher');
      if (p) p.hidden = true; if (l) l.hidden = false;
      return;
    }
  });

  /* Facet forms: any checkbox, select or slider change submits, so filtering
     and sorting stay server side and the URL always describes the view.

     THE FORM IS FOUND THROUGH THE CONTROL'S OWN .form PROPERTY, NOT closest().
     That distinction is the whole bug this replaced. The sort select is not
     nested inside the facet form at all: it sits in the toolbar, on the other
     side of the layout, and joins the form through form="sw-facets". closest()
     only walks ancestors, so it never found the form, and changing the sort did
     exactly nothing. The dropdown showed "Price, low to high" while the grid
     kept its original order, which is a worse failure than an error, because it
     looks like it worked.

     .form is the element's owning form and honours the form="" attribute, so it
     is right for both the controls inside the rail and the select outside it.
     The matches() guard keeps this from auto-submitting any other form on the
     page, which closest() used to do for free. */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches || el.matches('[data-sw-no-submit]')) return;
    var form = el.form || (el.closest ? el.closest('[data-sw-facet-form]') : null);
    if (!form || !form.matches('[data-sw-facet-form]')) return;

    /* A price slider sitting at its maximum expresses no constraint, so it must
       not travel with the submission. The rail even says so on screen, "Up to
       $250 · all prices", but the control still carried filter.v.price.lte=250
       into every facet change, quietly dropping the 6 products dearer than the
       slider's cap. Sorting the whole catalog went from 1307 products to 1301
       for no reason the reader could see.

       Disabled controls are not submitted, and the page navigates immediately
       after, so nothing visibly changes. */
    Array.prototype.forEach.call(form.querySelectorAll('[data-sw-price-max]'), function (r) {
      if (r.max !== '' && Number(r.value) >= Number(r.max)) r.disabled = true;
    });
    form.submit();
  });

  /* Price slider: show the value live. The submit on release is the handler
     above, since the slider sits inside the facet form. */
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-sw-price-max]')) return;
    var out = document.querySelector('[data-sw-price-label]');
    if (out) out.textContent = out.dataset.prefix + e.target.value;
  });

  /* Clearing the search box means "show me everything", not "show me nothing".

     A blank submit used to go to /search?q= , which renders the results
     template with search.performed false: an empty panel reading "Search the
     catalog" and no link out. The visitor had cleared their search and landed
     somewhere that looked broken. Send them to the All products grid instead,
     which is the real everything, with the facet rail and sort intact.

     The destination is rendered onto the form rather than hardcoded, so it
     follows the section's own All products collection and view suffix. With no
     destination, or with JavaScript off, the form submits normally and the
     results template's empty state carries the same link as a fallback. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form.sw-search') : null;
    if (!form) return;
    var q = form.querySelector('input[name="q"]');
    var dest = form.getAttribute('data-sw-empty');
    if (!q || !dest) return;
    if (q.value.trim() !== '') return;
    e.preventDefault();
    window.location.href = dest;
  });

  /* ------------------------------------------------------------- load more

     Fetches the next paginated page and appends its cards.

     Four things here are deliberate, and three of them are the fix for a real
     bug, so none of them should be simplified away.

     1. THE END OF THE LIST REMOVES THE BUTTON, IT DOES NOT HIDE IT. This used
        to set .hidden on .sw-loadwrap, which did nothing at all, because
        .sw-loadwrap is display:flex and an author declaration beats the user
        agent's [hidden]{display:none}. The button stayed on screen reading
        "Loading..." forever, still pointing at the final page, and every
        further click appended that same page again. A removed node cannot be
        un-hidden by a stylesheet. (The CSS now also honours [hidden] on the
        wrapper, so either mechanism works, but removal is what runs here.)

     2. ONE REQUEST AT A TIME. Two quick clicks would otherwise fire two
        fetches of the same URL and append the page twice.

     3. THE NEXT URL MUST ACTUALLY ADVANCE. If the response hands back the
        same url we just asked for, there is nothing further to ask for, so we
        stop rather than sit on a button that reloads one page forever.

     4. CARDS ALREADY ON THE PAGE ARE SKIPPED BY HANDLE. Pagination is an
        offset into a list that can shift underneath us if the catalog changes
        between two requests. A product appearing twice is worse than one
        arriving a moment late. */
  var loadingMore = false;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sw-load]');
    if (!btn) return;

    /* Busy: swallow the click rather than let the href navigate away. */
    if (loadingMore) { e.preventDefault(); return; }

    /* No state to work with, so let the plain link do its job. That is the
       no-JavaScript path and it should keep working. */
    if (!btn.dataset.next) return;
    e.preventDefault();

    loadingMore = true;
    var url = btn.dataset.next;
    var wrap = btn.closest('.sw-loadwrap');
    var label = btn.querySelector('span');
    var was = label ? label.textContent : '';
    if (label) label.textContent = 'Loading...';
    btn.setAttribute('aria-busy', 'true');

    /* The label counts the products the NEXT click will add, so it changes as
       you go: "Show 48 more" until the last batch, then "Show 3 more". That
       number is server rendered, so restoring the old text would leave a stale
       count on screen. Pass the incoming page's own label instead. */
    function settle(text) {
      loadingMore = false;
      btn.removeAttribute('aria-busy');
      if (label) label.textContent = text || was;
    }

    function finish() {
      /* Nothing left. Take the control out of the document entirely. */
      loadingMore = false;
      btn.removeAttribute('data-next');
      if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
      else { btn.removeAttribute('aria-busy'); if (label) label.textContent = was; }
    }

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-sw-grid]');
        var grid = document.querySelector('[data-sw-grid]');

        if (incoming && grid) {
          var seen = Object.create(null);
          Array.prototype.forEach.call(grid.children, function (card) {
            var h = card.getAttribute('data-handle');
            if (h) seen[h] = true;
          });
          Array.prototype.forEach.call(incoming.children, function (node) {
            var h = node.getAttribute('data-handle');
            if (h) {
              if (seen[h]) return;
              seen[h] = true;
            }
            grid.appendChild(node.cloneNode(true));
          });
          paintFavs(grid);
        }

        var nextBtn = doc.querySelector('[data-sw-load]');
        var nextUrl = nextBtn ? nextBtn.getAttribute('data-next') : '';
        if (nextUrl && nextUrl !== url) {
          btn.dataset.next = nextUrl;
          var nextLabel = nextBtn.querySelector('span');
          settle(nextLabel ? nextLabel.textContent.trim() : null);
        } else {
          finish();
        }
      })
      .catch(function () {
        /* Leave the button usable so the reader can try again. */
        settle();
      });
  });

  function init() {
    paintFavs();
    paintArt();
    filterToFavs();
    document.querySelectorAll('.sw-banner').forEach(initBanner);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Re-run after a theme-editor section reload. */
  document.addEventListener('shopify:section:load', init);
})();
